import { c as _c } from "react/compiler-runtime";
import { TestimonialQuoteItem } from "@/sanity/sanity.types";
import css from "./home-review-card.module.scss";
import DateString, { DateStringFormat } from "@/components/common/date-string/date-string";
interface HomeReviewCardProps {
  data: TestimonialQuoteItem;
}
const HomeReviewCard = props => {
  const $ = _c(15);
  const {
    author,
    date,
    quote
  } = props.data;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={css.homeReviewCardStars}>{"\u2605".repeat(5)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== quote) {
    t1 = <div className={css.homeReviewCardContent}>{t0}<p className={css.homeReviewCardText}>{quote}</p></div>;
    $[1] = quote;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== author) {
    t2 = <span className={css.homeReviewCardName}>{author}</span>;
    $[3] = author;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== date) {
    t3 = date ? <DateString date={date} format={DateStringFormat.SLASHES} /> : "";
    $[5] = date;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className={css.homeReviewCardDate}>{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className={css.homeReviewCardFooter}>{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <div className={css.homeReviewCard}>{t1}{t5}</div>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default HomeReviewCard;